import {
  AppointmentResponse,
  BankResponse,
  CreditCardResponse,
} from "@/data/dtos/responses";
import { UpdateBankInput } from "@/domain/dtos/inputs";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { PaymentDataSource } from "./PaymentDataSource";

export class PaymentRemoteDataSource implements PaymentDataSource {
  constructor(private readonly api: ApiService) {}

  async getCreditCards() {
    const { data } = await this.api.get<CreditCardResponse[]>(Endpoints.cards);

    if (!data) {
      return [];
    }

    return data;
  }

  createCreditCard(card_hash: string) {
    return this.api.post(Endpoints.cards, { card_hash });
  }

  async deleteCard(card_id: string) {
    const { message } = await this.api.delete(Endpoints.cards, { card_id });

    return {
      message: message || "Seu cartão foi removido com sucesso",
    };
  }

  async getStripeAccountLink(id: number | string) {
    const { data } = await this.api.get<{ url: string }>(
      `${Endpoints.stripe_connect_onboarding}/${id}`,
    );

    if (!data) {
      throw new Error("Ocorreu um erro. Por favor, tente novamente.");
    }

    return data;
  }

  // TODO criar o type request
  updateStripePending = (params: any) => {
    return this.api.post(Endpoints.update_stripe_pending, params, {
      encodeType: "formData",
    });
  };

  async getStripeConnectResetURL(id: number | string) {
    return this.api.post(`${Endpoints.stripe_connect_reset}/${id}`, {});
  }

  async paymentRetry(
    appointmentId: number,
    cardId: string,
  ): Promise<AppointmentResponse | undefined> {
    const { data } = await this.api.post<
      AppointmentResponse,
      { card_id: string }
    >(`${Endpoints.appointments}/${appointmentId}/payment-retry`, {
      card_id: cardId,
    });

    return data;
  }

  async getBanks() {
    const { data } = await this.api.get<BankResponse[]>(Endpoints.bank_codes);

    if (!data) {
      return [];
    }

    return data;
  }

  // TODO criar o type request
  async updateBank(params: UpdateBankInput) {
    return this.api.post(Endpoints.my_banks, params);
  }
}
